// release.schema.json source — release profile consumed by `deploy-v1`
// controller executor (`workflows/autopilot/release.md`) and G3 gate
// evidence (spec §"Gate, danh tính và tài nguyên", G3 row: "Candidate
// SHA/base hoặc merge candidate, review/CI evidence, release manifest hash,
// artifact/profile, môi trường và migration/rollback cụ thể.").
import { z } from "zod";

export const ReleaseSchema = z
  .object({
    schema_version: z.literal(1),
    mission_id: z.string().min(1),
    candidate_sha: z.string().min(1),
    base_sha: z.string().min(1),
    merge_candidate: z.boolean(),
    review_evidence: z
      .object({
        risk: z.enum(["low", "medium", "high", "critical"]),
        report_path: z.string().min(1),
        sha256: z.string().regex(/^[0-9a-f]{64}$/i),
      })
      .strict(),
    ci_evidence: z.array(
      z
        .object({
          check_name: z.string().min(1),
          status: z.enum(["pass", "fail", "pending"]),
          url: z.string().optional(),
        })
        .strict(),
    ),
    release_manifest_hash: z.string().regex(/^[0-9a-f]{64}$/i),
    environment: z.string().min(1),
    migration: z
      .object({
        required: z.boolean(),
        recipe_path: z.string().optional(),
        rollback_recipe_path: z.string().optional(),
      })
      .strict(),
    // Deploy/rollback are controller-executed only (executor=controller) —
    // no `agent`/`command_adapter` field here on purpose (§5.1: "revert/
    // deploy do controller thực thi recipe đã duyệt").
    rollback_plan_path: z.string().min(1),
  })
  .strict();

export type Release = z.infer<typeof ReleaseSchema>;
